import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ScanOcHash from '../../components/ScanOcHash';
import './index.less';

const ScanOcHashPage: React.FC = () => {
  const { hash } = useParams();
  const navigate = useNavigate();

  if (!hash) return null;

  return (
    <ScanOcHash 
      hash={hash}
      onCancel={() => navigate('/')}
      onCollect={({ bpm }) => navigate(`/?bpm=${bpm}&type=oc`)}
    />
  );
};

export default ScanOcHashPage; 